function isNaN(value) {
    return Number.isNaN(value);
}

export { isNaN };
